import type { Release } from '../releases.ts';

export default {
  version: '0.18.3',
  date: '2026-10-02',
  title: 'Live player',
  summary: [
    'A recording in progress shows a RECORDING badge and a timeline that grows',
    'A LIVE indicator shows how far behind live you are, with Go live',
    'Fixed: the live player starts at the live edge once everything recorded has loaded',
  ],
  features: [],
  fixes: [
    'Watching a recording in progress: a RECORDING badge, a timeline that grows with the recording and keeps the playhead at its right end while playing live, a LIVE indicator, and how far behind live with Go live after scrubbing back',
    'The live player starts playing at the live edge once everything recorded so far has loaded, instead of sometimes starting earlier or paused',
  ],
} satisfies Release;
